import {useLocalStorageNew} from "./useLocalStorageNew";
import {IDENTITY_PROVIDER_TYPES, SESSION_WILL_EXPIRED_DURATION} from "../utils/constants";


export const useSession = () => {
    const[setStorageSession, getStorageSession] = useLocalStorageNew("session", {});

    function parseToken(token) {
        if (!token || !token.includes(".")) {
            return null;
        }

        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            return JSON.parse(jsonPayload);
        } catch (e) {
            console.log(e);
            return null;
        }
    }

    function checkExpired(token='') {
        if (!token) {
            const session = getStorageSession();
            const {authorization=''} = session;
            token = authorization
        }
        const now = Date.now();
        const payLoad = parseToken(token);
        return !payLoad || !payLoad.exp || (now > payLoad.exp * 1000);
    }

    function checkWillExpired() {
        const session = getStorageSession();
        const now = Date.now();
        const {authorization=''} = session;
        const payLoad = parseToken(authorization);
        return !payLoad || !payLoad.exp || (now + SESSION_WILL_EXPIRED_DURATION > payLoad.exp * 1000);
    }

    function isLoggedIn() {
        let session = getStorageSession();
        return !!session && Object.keys(session).length > 0;
    }

    function isFromGradeLink() {
        let session = getStorageSession();
        return session.hasOwnProperty("gradedLink") && !!session.gradedLink;
    }

    function parseSessionToken() {
        const session = getStorageSession();
        const {authorization=''} = session;
        const payLoad = parseToken(authorization);
        return payLoad;
    }

    function isFromLMS() {
        let {idpType, intType} = getStorageSession();

        return !!idpType && !!intType && idpType === IDENTITY_PROVIDER_TYPES.LMS;
    }

    function isFromSAML() {
        let {idpType} = getStorageSession();

        return !!idpType && idpType === IDENTITY_PROVIDER_TYPES.SAML;
    }

    function getSession() {
        return getStorageSession();
    }

    function setSession(session={}) {
        return setStorageSession(session);
    }



    return {checkExpired, checkWillExpired, parseToken, isLoggedIn, isFromGradeLink, isFromLMS, isFromSAML, getSession, setSession, parseSessionToken}

}